import React, { useState, useEffect } from "react";
import { makeStyles } from "@material-ui/core/styles";
import {
  CardContent,
  Card,
  Typography,
  MenuItem,
  Select,
  Dialog,
  DialogContent,
  DialogTitle,
  Button,
  IconButton,
  CircularProgress,
} from "@material-ui/core";
import { Remove } from "@material-ui/icons";
import ImageSetPreview from "./imageSetPreviewComponent"; // kept for reference, no longer rendered

import AddIcon from "@material-ui/icons/Add";
import { getServerUri } from "../modules/uriUtility";
import _ from "lodash";
import DialogImageSetDelete from "./dialogImageSetDelete";
import ReactGA4 from "react-ga4";
import Tooltip from "@mui/material/Tooltip";
ReactGA4.initialize("G-TB46JQ70PR", {
  debug: false,
  gaOptions: {
    userId: localStorage.getItem("user.id"),
  },
});
const useStyles = makeStyles({
  iconButton: {
    padding: 0,
  },
});

/**
 * @param props.componentID
 * @param props.componentType
 * @param props.path
 * @param props.setValue
 * @param props.value
 * @param props.images
 * @param props.classes
 * @param props.replaces
 * @param props.componentID
 * @param props.selectedImageSetID
 * @param props.insertMediaPathValue
 * @param props.selectedBase
 * @param props.createSnackbar
 * @param props.deleteImageSetFromMedia
 * @param props.userPermissions
 * @param props.setIsDialogConfirmRefreshOpen
 * @param props.setIsDialogCircularProgressOpen
 * @param props.isVisible
 * @returns {JSX.Element}
 */
export default function selectorImageSet(props) {
  const [isDialogOpen, setIsDialogOpen] = useState(false);
  const [errorCount, setErrorCount] = useState(0);
  const [images, setImages] = useState(imagesToView(_.get(props, "images", [])));
  const [isDeleteImageSetDialogOpen, setIsDeleteImageSetDialogOpen] = useState(false);
  const [imageSetToDelete, setImageSetToDelete] = useState(null);
  const [isUploading, setIsUploading] = useState(false);
  const [fileArray, setFileArray] = useState(new Array(20).fill(null));
  const [uploadedFileNames, setUploadedFileNames] = useState([]);

  const classes = useStyles();
  const imageSets = images.reduce((arr, item) => {
    const imageSet = _.get(item, "imageSet");
    if (!_.isNil(imageSet) && arr.indexOf(imageSet) === -1) {
      arr.push(imageSet);
    }
    return arr;
  }, []);

  const defaultImageSetID = _.get(imageSets, "[0]", "");
  const fileSelectors = [];
  const [uploadStatus, setUploadStatus] = useState("ready");
  const [selectedImageSetID, setSelectedImageSetID] = useState(
    isSelectionValid(_.get(props, "selectedImageSetID")) ? _.get(props, "selectedImageSetID") : defaultImageSetID
  );

  useEffect(() => {
    checkFilesValid();
  }, [isDialogOpen]);

  useEffect(() => {
    setImages(imagesToViewSorted(_.get(props, "images", [])));
  }, [_.get(props, "images", []), _.size(_.get(props, "images", []))]);

  function imagesToView(images) {
    let imageLists = images.filter((image) => {
      return (
        !_.isNil(_.get(image, "bucket")) &&
        !_.isNil(_.get(image, "imageSet")) &&
        _.get(image, "bucket") === _.get(props, "bucket")
      );
    });

    return imageLists;
  }
  function gettingMargin(numberMargin) {
    if (props.tooltip != undefined) {
      if (numberMargin) {
        return numberMargin.toString() + "px";
      }
    } else return (0).toString() + "px";
  }

  function imagesToViewSorted(images) {
    let imageLists = images.filter((image) => {
      return (
        !_.isNil(_.get(image, "bucket")) &&
        !_.isNil(_.get(image, "imageSet")) &&
        _.get(image, "bucket") === _.get(props, "bucket")
      );
    });

    let newImageLists = [];
    let Nilexists = false;
    imageSets.map((imageSet) => {
      let neSetItems = [];

      imageLists.map((imageRecord, index) => {
        if (_.get(imageRecord, "imageSet") === imageSet) {
          if (_.isNil(imageRecord.index) === true) {
            neSetItems[index] = imageRecord;
          } else {
            neSetItems[imageRecord.index] = imageRecord;
          }
        }
      });
      neSetItems.map((it) => newImageLists.push(it));
    });

    return newImageLists;
  }

  useEffect(() => {
    const recordedSelectedImageSetID = _.get(props, "selectedImageSetID", "");
    if (isSelectionValid(recordedSelectedImageSetID)) {
      setSelectedImageSetID(recordedSelectedImageSetID);
    } else if (isSelectionValid(defaultImageSetID)) {
      selectImageSet(defaultImageSetID);
    }
  }, [_.get(props, "selectedVersion")]);

  function isSelectionValid(imageSetID, newImages) {
    let images2;
    if (_.isNil(newImages)) {
      images2 = images;
    } else {
      images2 = newImages;
    }
    const foundImages = images2.filter((image) => {
      return String(image.imageSet) === String(imageSetID);
    });
    return foundImages.length > 0 || imageSetID === "";
  }

  const variants = new Set(Object.keys(_.get(props, "destinations", {})));
  const variantList = Array.from(variants);
  // singleUpload: one picture feeds every variant. The upload still posts one entry
  // per variant, so the resulting image set — and everything downstream, including
  // the game's per-variant lookups — keeps exactly the shape it has today.
  const isSingleUpload = Boolean(_.get(props, "singleUpload")) && variantList.length > 0;
  const uploadCards = isSingleUpload ? variantList.slice(0, 1) : variantList;

  function getSelectedImagesByImageSetID(imageSetID, newImages) {
    const selectedImages = [];
    newImages.forEach((image) => {
      if (_.get(image, "imageSet") === imageSetID) {
        const newImage = _.cloneDeep(image);
        _.set(newImage, "destination", _.get(props, `destinations.${_.get(newImage, "variant")}`));
        selectedImages.push(newImage);
      }
    });
    return selectedImages;
  }
  function selectImageSet(imageSetID, newImages) {
    if (!isSelectionValid(imageSetID, newImages)) return;
    setSelectedImageSetID(imageSetID);
    let images2;
    if (_.isNil(newImages)) {
      images2 = images;
    } else {
      images2 = newImages;
    }
    props.setValue({
      value: getSelectedImagesByImageSetID(imageSetID, images2),
    });
  }
  function checkFilesValid() {
    let fileSelectorsErrorCount = 0;
    fileSelectors.forEach((fileSelector, index, array) => {
      let selectorErrorCount = 0;
      if (_.get(document.getElementById(fileSelector.id), "files.length", 0) === 0) {
        selectorErrorCount++;
        fileSelectorsErrorCount++;
      }
      if (_.get(document.getElementById(fileSelector.id), "files.length", 0) > 1) {
        selectorErrorCount++;
        fileSelectorsErrorCount++;
      }
      if (selectorErrorCount > 0) return;
    });
    setErrorCount(fileSelectorsErrorCount);
    return fileSelectorsErrorCount > 0 ? false : true;
  }

  function setInputFileListEmpty(inputId) {
    let list = new DataTransfer();
    document.getElementById(inputId).files = list.files;
  }
  const handleFileUpload = (event, index, imgID, buttonID) => {
    const file = event.target.files[0];
    if (!file) return;
    const newFileName = file.name.substring(0, file.name.lastIndexOf(".")) || file.name;
    const fileSizeInMB = file.size / (1024 * 1024);
    if (fileSizeInMB > 3) {
      props.createSnackbar("File size should be 3MB ", "warning", false);
      return;
    }
    const objectURL = URL.createObjectURL(file);
    const img = new Image();
    img.onload = () => {
      if (img.height > 4096 || img.width > 4096) {
        props.createSnackbar("Height and width must not exceed 4096px", "error");
        URL.revokeObjectURL(objectURL);
        return;
      }
      const updatedArray = [...fileArray];
      updatedArray[index] = file;
      setFileArray(updatedArray);
      const newNames = [...uploadedFileNames];
      newNames[index] = newFileName;
      setUploadedFileNames(newNames);
      const imgEl = document.getElementById(imgID);
      if (imgEl) { imgEl.src = objectURL; imgEl.style.display = "block"; }
      const btnEl = document.getElementById(buttonID);
      if (btnEl) btnEl.style.display = "none";
      checkFilesValid();
    };
    img.src = objectURL;
  };
  return (
    <div id={`${props.id}.Div`}>
      {" "}
      {props.isVisible && (
        <>
          {_.get(props, "label") && (
            <Typography style={{ marginTop: gettingMargin(props.tooltipLength) }} id="discrete-slider" gutterBottom>
              {_.get(props, "label")}
            </Typography>
          )}
          <div
            style={{
              display: "flex",
              flexDirection: "row",
              alignItems: "center",
              justifyContent: "flex-start",
            }}
          >
            <Select
              key={`${props.componentID}.${props.path}`}
              onChange={(event) => {
                if (props.userPermissions["editContent"] === false) {
                  props.createSnackbar(
                    "You do not have permission to update, contact your administrator.",
                    "warning",
                    false
                  );
                  return;
                }
                selectImageSet(event.target.value);
              }}
              className={props.classes.imageSelector}
              value={selectedImageSetID}
            >
              {imageSets.map((imageSet) => (
                <MenuItem
                  style={{
                    display: "flow",
                    justifyContent: "space-between",
                    width: "100%",
                  }}
                  key={imageSet}
                  value={imageSet}
                >
                  <div
                    style={{
                      display: "flex",
                      width: "60%",
                    }}
                  >
                    {(isSingleUpload
                      // Every variant holds the same picture — one thumbnail says it all.
                      ? images.filter((i) => _.get(i, "imageSet") === imageSet).slice(0, 1)
                      : images
                    ).map(
                      (imageRecord) =>

                        _.get(imageRecord, "imageSet") === imageSet && (

                          <Tooltip
                            key={_.get(imageRecord, "_id")}
                            id="uploadedFileName_tooltip"
                            title={imageRecord.uploadedFileName ? imageRecord.uploadedFileName[imageRecord.index] : ""}
                            enterDelay={1000}
                            leaveDelay={200}
                            placement="bottom-start"
                          >
                            <img
                              key={_.get(imageRecord, "_id")}
                              style={{
                                height: "50px",
                                maxWidth: "30px",
                                objectFit: "contain",
                                marginRight: "0.5rem",
                              }}
                              src={`images/${imageRecord.thumbFile || imageRecord.file}`}
                            />
                          </Tooltip>
                        )
                    )}
                  </div>

                  {selectedImageSetID !== imageSet && (
                    <div
                      style={{
                        float: "right",
                      }}
                    >
                      <IconButton
                        className={classes.iconButton}
                        onClick={(e) => {
                          e.stopPropagation();
                          if (props.userPermissions["deleteContent"] === false) {
                            props.createSnackbar(
                              "You do not have permission to delete, contact your administrator.",
                              "warning",
                              false
                            );
                            return;
                          }
                          setImageSetToDelete(imageSet);
                          setIsDeleteImageSetDialogOpen(true);
                        }}
                      >
                        <Remove />
                      </IconButton>
                    </div>
                  )}
                </MenuItem>
              ))}
            </Select>
            <Dialog
              open={isDialogOpen}
              onClose={(e) => {
                setIsDialogOpen(false);
              }}
            >
              <DialogTitle style={{ textAlign: "center" }}>{"Select Images"}</DialogTitle>
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                <div
                  style={{
                    display: "flex",
                    flexDirection: "row",
                    justifyContent: "center",
                    alignItems: "center",
                    flexFlow: "row wrap",
                  }}
                >
                  {uploadCards.map((variant, index) => {
                    const imgID = `${_.get(props, "componentID")}-${variant}-img`;
                    const buttonID = `${_.get(props, "componentID")}-${variant}-button`;
                    const inputID = `${_.get(props, "componentID")}-${variant}-input`;
                    fileSelectors.push({
                      id: inputID,
                      variant,
                      index: index,
                      replaces: _.get(props, `replaces.${variant}`, ""),
                    });
                    return (
                      <div
                        key={variant}
                        style={{
                          display: "flex",
                          flex: "1 0 auto",
                          flexDirection: "column",
                          alignItems: "center",
                          justifyContent: "center",
                          margin: "5px 15px 5px 15px",
                        }}
                      >
                        <div id="index" />
                        <Typography style={{ display: "block" }}>
                          {isSingleUpload ? _.get(props, "label", variant) : variant}
                        </Typography>
                        <input
                          id={inputID}
                          type={"file"}
                          hidden={"hidden"}
                          accept=".jpeg, .png, .jpg, .webp"
                          onChange={(event) => handleFileUpload(event, index, imgID, buttonID)}
                        />
                        <Card
                          // id={imageSetCard}
                          className={props.classes.imageUploadPreview}
                          onClick={(e) => {
                            if (props.userPermissions["manageAssets"] === false) {
                              props.createSnackbar(
                                "You do not have permission to insert, contact your administrator",
                                "warning",
                                false
                              );
                              return;
                            }
                            document.getElementById(inputID).click();
                          }}
                        >
                          <CardContent
                            style={{
                              display: "flex",
                              flex: "1 0 auto",
                              flexDirection: "column",
                              alignItems: "center",
                              justifyContent: "center",
                              weight: "100%",
                              height: "100%",
                            }}
                          >
                            <img
                              id={imgID}
                              style={{
                                display: "none",
                                objectFit: "contain",
                                width: "100%",
                                height: "100%",
                              }}
                            />
                            <AddIcon id={buttonID} style={{ width: 50, height: 50 }}></AddIcon>
                          </CardContent>
                        </Card>
                      </div>
                    );
                  })}
                </div>
                <div
                  style={{
                    width: "100%",
                    height: "100%",
                    display: "flex",
                    flexDirection: "row",
                    justifyContent: "center",
                    alignItems: "center",
                  }}
                >
                  <CircularProgress
                    color={"secondary"}
                    style={{
                      textAlign: "center",
                      display: isUploading ? "block" : "none",
                    }}
                  ></CircularProgress>
                  <Button
                    style={{
                      width: "100%",
                      height: "100%",
                      margin: 5,
                      display: !isUploading ? "block" : "none",
                    }}
                    disabled={!isDialogOpen || errorCount > 0}
                    onClick={(e) => {
                      setIsUploading(true);
                      const formData = new FormData();
                      formData.append("path", _.get(props, "path"));
                      formData.append("accessToken", localStorage.getItem("session.accessToken"));
                      formData.append("componentType", _.get(props, "componentType"));
                      formData.append("bucket", _.get(props, "bucket"));
                      formData.append("compress", String(localStorage.getItem("settings.autoCompress") !== "false"));
                      // let newFileArray= fileArray.reverse();
                      // One entry per variant either way; singleUpload just points
                      // every variant at the one picked file.
                      variantList.forEach((variant, variantIndex) => {
                        const fileIndex = isSingleUpload ? 0 : variantIndex;
                        formData.append("variant", variant);
                        formData.append("index", variantIndex);
                        formData.append("files", fileArray[fileIndex]);
                        formData.append("uploadedFileName", uploadedFileNames[fileIndex]);
                      });

                      setFileArray([]);

                      if (errorCount > 0) return;
                      fetch(getServerUri("media/uploadImageSet"), {
                        method: "POST",
                        body: formData,
                      }).then((response) => {
                        setIsUploading(false);
                        if (response.status !== 200) {
                          setIsDialogOpen(false);
                          if (response.status === 401) {
                            props.createSnackbar(
                              "You are not authorized to insert, contact your administrator.",
                              "warning"
                            );
                          } else {
                            props.createSnackbar("Image set upload failed. (" + response.status + ")", "error", false);
                          }
                          response
                            .text()
                            .then((textResponse) => {
                              console.error("Upload imageSet failed: ", textResponse);
                            })
                            .catch((err) => {
                              console.error(err);
                            });
                        } else {
                          response
                            .json()
                            .then((objectResponse) => {
                              console.info("Upload imageSet Succeeded", objectResponse);
                              const newImages = _.cloneDeep(images);
                              const newRecords = _.get(objectResponse, "records", []);
                              newImages.push(...newRecords);
                              setImages(newImages);
                              props.insertMediaPathValue({
                                path: "images",
                                value: newRecords,
                              });
                              setUploadStatus("complete");
                              const newImageSetID = newRecords[0].imageSet;
                              setSelectedImageSetID(newImageSetID);
                              selectImageSet(newImageSetID, newImages);

                              setIsDialogOpen(false);
                              const compression = _.get(objectResponse, "compression");
                              console.log("[SmartCompress] imageSet response:", compression);
                              if (compression && parseFloat(compression.savedPercent) > 0) {
                                props.createSnackbar(<span>Image optimized by <strong>{compression.savedPercent}%</strong> with Smart Auto-Optimize.</span>, "success", false);
                              } else if (!compression) {
                                props.createSnackbar(
                                  "Smart Auto-Optimize is disabled. Images are uploaded without optimization.",
                                  "warning",
                                  false,
                                  () => window.dispatchEvent(new CustomEvent("openToolSettings")),
                                  "Enable in Tool Settings"
                                );
                              }
                              ReactGA4.event({
                                category: "Preview",
                                action: "Image Set ",
                                label:
                                  "filename: " +
                                  formData.resizedFile +
                                  " path " +
                                  formData.path +
                                  " ,base: " +
                                  props.selectedBase.title +
                                  " ,originalVersion: " +
                                  props.selectedVersion.title,
                                dimension1: localStorage.getItem("user.id"),
                              });
                            })
                            .catch((err) => {
                              console.error(err);
                              setIsDialogOpen(false);
                            });
                        }
                      }).catch((err) => {
                        console.error(err);
                        setIsUploading(false);
                        setIsDialogOpen(false);
                        props.createSnackbar("Could not reach server. Please check your connection.", "error", false);
                      });
                    }}
                  >
                    {uploadStatus === "ready" && "Upload"}
                    {uploadStatus === "complete" && "Uploaded Successfully"}
                  </Button>
                </div>
                <div>{errorCount > 0 && <div style={{ padding: "0.5rem" }}>* Please select all assets.</div>}</div>
              </div>
            </Dialog>
            <IconButton
              id={`${props.id}.uploadButton`}
              style={{ padding: 0 }}
              onClick={(e) => {
                var className = props.classes.imageUploadPreview;
                if (props.userPermissions["manageAssets"] === false) {
                  props.createSnackbar(
                    "You are not authorized to insert, contact your administrator.",
                    "warning",
                    false
                  );
                  return;
                }
                if (props.userPermissions["editContent"] === false) {
                  props.createSnackbar(
                    "You are not authorized to update, contact your administrator.",
                    "warning",
                    false
                  );
                  return;
                }
                setUploadStatus("ready");
                setIsDialogOpen(true);
              }}
            >
              <AddIcon />
            </IconButton>
            <DialogImageSetDelete
              isOpen={isDeleteImageSetDialogOpen}
              setIsOpen={(value) => setIsDeleteImageSetDialogOpen(value)}
              createSnackbar={props.createSnackbar}
              imageSetToDelete={imageSetToDelete}
              images={images}
              setImages={setImages}
              selectImageSet={selectImageSet}
              deleteImageSetFromMedia={props.deleteImageSetFromMedia}
              defaultImageSetID={defaultImageSetID}
            />
          </div>
        </>
      )}
    </div>
  );
}
